/*
 * @Author: LiZhiWei
 * @Date: 2026-01-15 17:49:31
 * @LastEditors: LiZhiWei
 * @LastEditTime: 2026-01-23 16:09:37
 * @Description:
 */
import { http } from '~/utils/fetch'

/**
 * 申请入驻
 * @param params { company: string, contacts: string, phone: string, remark: string }
 */
export const applyPartner = (data: {
  company: string
  contacts: string
  phone: string
  remark: string
}) => {
  return http.request({
    url: '/app/hgj/partners',
    method: 'POST',
    data,
  })
}
